import React from 'react';

import { Box, Button, Grid, TextField, Typography } from '@material-ui/core';

import SubHeader from '../../../../components/Header/SubHeader.component';
import Loader from '../../../../components/LoaderSplash/Loader.component';
import SharedDialog from '../../../../components/SharedDialog/SharedDialog.component';
import EditProfileDataProvider from '../../../../context/account/editProfile.provider';
import useEditProfile from './hooks';

const EditProfileWrapped = () => {
  const {
    loading,
    open,
    onClose,
    handleSubmit,
    errors,
    handleChange,
    values,
    user,
    plusPhone,
    setPlusPhone,
    onOpen,
  } = useEditProfile();

  return (
    <>
      <Box display={loading ? 'block' : 'none'}>
        <Loader action={'Cargando información personal'}></Loader>
      </Box>

      <SharedDialog
        open={open}
        content={
          <Box>
            <Typography variant="h6">
              {' '}
              ¿Querés guardar los cambios en tu perfil?{' '}
            </Typography>
          </Box>
        }
        onClose={onClose}
        actions={
          <Grid container>
            <Grid item xs={12} sm={6}>
              <Box m={2}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={handleSubmit}
                >
                  Guardar cambios
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box m={2}>
                <Button
                  variant="outlined"
                  color="primary"
                  fullWidth
                  onClick={onClose}
                >
                  Descartar
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      ></SharedDialog>

      <SubHeader
        content={
          <Box>
            <Typography variant="h6"> Editar perfil </Typography>
          </Box>
        }
      ></SubHeader>

      <Box my={3}>
        <Grid container justify="center">
          <Grid item xs={11} md={8} lg={6}>
            <Typography style={{ fontWeight: 'bold' }}>
              {' '}
              Datos de contacto{' '}
            </Typography>
            <Box mb={2} mt={2}>
              <Typography variant="subtitle2"> Teléfono * </Typography>
              <TextField
                size="small"
                error={Boolean(errors['phone_number'])}
                helperText={errors['phone_number']}
                onChange={handleChange}
                fullWidth={true}
                name="phone_number"
                id="phone_number"
                placeholder="Teléfono *"
                variant="outlined"
                value={values.phone_number}
              />
            </Box>
            <Box mb={2}>
              <Typography variant="subtitle2"> Email </Typography>
              <TextField
                type="email"
                size="small"
                error={Boolean(errors['email'])}
                helperText={errors['email']}
                onChange={handleChange}
                fullWidth={true}
                name="email"
                id="email"
                placeholder="Ingresá tu email"
                variant="outlined"
                value={values.email}
              />
            </Box>
            {user.emergency_phone || plusPhone ? (
              <Box mb={2}>
                <Typography variant="subtitle2">
                  {' '}
                  Contacto de emergencia o alternativo{' '}
                </Typography>
                <TextField
                  size="small"
                  error={Boolean(errors['emergency_phone'])}
                  helperText={errors['emergency_phone']}
                  onChange={handleChange}
                  fullWidth={true}
                  name="emergency_phone"
                  id="emergency_phone"
                  placeholder="Ingresá su teléfono"
                  variant="outlined"
                  value={values.emergency_phone}
                />
              </Box>
            ) : (
              <Box mb={2}>
                <Button color="primary" onClick={() => setPlusPhone(true)}>
                  {' '}
                  + Sumar contacto de emergencia o alternativo{' '}
                </Button>
              </Box>
            )}
            <Box mb={4} mt={2}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                disabled={!!Object.keys(errors).length}
                onClick={onOpen}
              >
                Guardar
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

const EditProfile = () => (
  <EditProfileDataProvider>
    <EditProfileWrapped />
  </EditProfileDataProvider>
);

export default EditProfile;
